var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyProfilePic = function SvgEmptyProfilePic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.452 12.516C18.732 11.9 18.9 11.228 18.9 10.5C18.9 7.798 16.702 5.6 14 5.6C13.272 5.6 12.6 5.768 11.984 6.048L18.452 12.516Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.272 0 0 6.272 0 14C0 21.728 6.272 28 14 28C21.728 28 28 21.728 28 14C28 6.272 21.728 0 14 0ZM2.8 14C2.8 11.41 3.682 9.03 5.166 7.14L9.17 11.144C9.464 13.328 11.172 15.05 13.356 15.33L16.436 18.41C15.638 18.27 14.826 18.2 14 18.2C10.752 18.2 7.77 19.32 5.404 21.168C3.78 19.222 2.8 16.73 2.8 14ZM14 25.2C11.564 25.2 9.324 24.416 7.49 23.1C9.324 21.784 11.564 21 14 21C16.436 21 18.676 21.784 20.51 23.1C18.676 24.416 16.436 25.2 14 25.2ZM22.834 20.86L7.14 5.166C9.03 3.682 11.41 2.8 14 2.8C20.188 2.8 25.2 7.812 25.2 14C25.2 16.59 24.318 18.956 22.834 20.86Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyProfilePic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-profile-pic.c81c52549aa35a8057eba5492b8900a1.svg";